import { ActionTypes } from '../actions/types';

const initialState = {
  mautlaender: [],
  anfrageGestartet: false,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_LAENDER_MAUT: {
      return {
        ...state,
        mautlaender: payload,
      };
    }
    case ActionTypes.GET_MAUT: {
      return {
        ...state,
        mautbetrag: payload.mautbetrag,
        message: payload.message,
        param: payload.param,
        anfrageGestartet: payload.anfrageGestartet,
      };
    }
    case ActionTypes.ANFRAGE_GESTARTET: {
      return {
        ...state,
        anfrageGestartet: payload,
      };
    }
    default:
      return state;
  }
}
